import { PortalLayout } from './PortalLayout';

/**
 * Datenschutzerklärung. Beschreibt, was Chest Catalog tatsächlich speichert (architecture.md 3, Aufbewahrung 3.7).
 * Bei neuen Daten, Diensten oder Fristen hier mitpflegen.
 */
export function PrivacyPage() {
  return (
    <PortalLayout>
      <section className="prose">
        <h1>Datenschutzerklärung</h1>
        <p className="muted">Stand: Oktober 2026</p>

        <h2>Verantwortlicher</h2>
        <p>
          Verantwortlich für die Verarbeitung personenbezogener Daten auf app.chest-catalog.de ist der im{' '}
          <a href="https://lrtv.dev/impressum.html">Impressum</a> genannte Betreiber. Dort findest du auch die
          Kontaktdaten für alle Fragen zum Datenschutz.
        </p>

        <h2>Kurz gesagt</h2>
        <ul>
          <li>Wir speichern nur, was Chest Catalog zum Funktionieren braucht: deinen Minecraft-Account und die Kisten, die die Mod meldet.</li>
          <li>Keine Werbung, kein Tracking, keine Analyse-Dienste. Schriften und alle Dateien liegen auf unserem Server.</li>
          <li>Keine E-Mail-Adresse, kein Passwort. Anmeldedaten speichern wir nur als nicht umkehrbaren Hash.</li>
          <li>Du kannst dein Konto jederzeit selbst löschen.</li>
        </ul>

        <h2>Aufruf der Webseite</h2>
        <p>
          Beim Aufruf speichert der Webserver ein Zugriffsprotokoll: IP-Adresse, Zeitpunkt, aufgerufene Adresse,
          Statuscode und Browserkennung. Wir brauchen das, um den Dienst sicher zu betreiben und Angriffe zu erkennen
          (Art. 6 Abs. 1 lit. f DSGVO). Die Protokolle werden nach 14 Tagen gelöscht. Zum Schutz vor Missbrauch zählt der
          Server außerdem Anfragen pro IP-Adresse; diese Zähler liegen nur im Arbeitsspeicher und verfallen nach höchstens
          10 Minuten.
        </p>

        <h2>Dein Konto</h2>
        <p>
          Ein Konto entsteht, wenn du dich in der Mod mit einem Beta-Code anmeldest. Wir speichern dazu die UUID und den
          Namen deines Minecraft-Accounts, wann das Konto angelegt wurde und zuletzt aktiv war, den Kontostatus, ob du
          Admin bist, welchen Beta-Code du eingelöst hast und in welchem Team du bist. Rechtsgrundlage ist die
          Bereitstellung des Dienstes, den du nutzen möchtest (Art. 6 Abs. 1 lit. b DSGVO). Die Daten bleiben gespeichert,
          bis du dein Konto löschst.
        </p>

        <h2>Kisten und ihr Inhalt</h2>
        <p>
          Die Mod übermittelt die Kisten, die du registrierst: Serveradresse, Dimension, Koordinaten, den Namen der Kiste,
          den Inhalt (Gegenstände, Mengen, Anzeigenamen und Eigenschaften wie Verzauberungen) sowie wann und von wem der
          Inhalt zuletzt geändert wurde. Sehen können das du, deine Teammitglieder und die Admins. Entfernst du eine Kiste,
          löschen wir ihren Inhalt sofort; ein Eintrag ohne Inhalt bleibt 30 Tage, damit die Mods deiner Teammitglieder das
          Entfernen mitbekommen (Art. 6 Abs. 1 lit. b DSGVO).
        </p>

        <h2>Anmeldung im Spiel und Geräte</h2>
        <p>
          Bei der Anmeldung in der Mod schickt unser Server deinen Spielernamen und einen einmaligen Prüfwert an den
          Sitzungsdienst von Mojang (Mojang AB, Teil von Microsoft). Mojang bestätigt damit, dass der Account wirklich
          dir gehört; so funktioniert auch jeder normale Minecraft-Server. Für jede angemeldete Mod speichern wir eine
          Sitzung mit Mod-Version, Zeitpunkt der Anmeldung und letzter Nutzung. Sie verfällt nach 90 Tagen ohne Nutzung;
          in der Geräteliste im Portal kannst du sie jederzeit beenden. Anmeldungen im Browser gelten 7 Tage ab der
          letzten Nutzung. Einmal-Links aus dem Spiel sind 5 Minuten gültig und werden spätestens 15 Minuten nach Ablauf
          gelöscht.
        </p>

        <h2>Anmelden mit Microsoft oder Discord</h2>
        <p>
          Wenn du „Mit Microsoft anmelden“ nutzt, meldest du dich direkt bei Microsoft an. Wir erhalten danach nur die
          UUID und den Namen deines Minecraft-Accounts und verwerfen alle Zugangsdaten von Microsoft sofort. Admins können
          zusätzlich Discord verknüpfen; dann speichern wir die Discord-ID und den Discord-Namen. Microsoft und Discord
          verarbeiten deine Daten bei der Anmeldung nach ihren eigenen Datenschutzerklärungen, auch in den USA. Beide sind
          unter dem EU-US Data Privacy Framework zertifiziert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.
        </p>

        <h2>Cookies und lokaler Speicher</h2>
        <ul>
          <li>
            <span className="mono">cc_session</span>: hält dich im Browser angemeldet, 7 Tage ab der letzten Nutzung.
          </li>
          <li>
            <span className="mono">cc_oauth</span>: nur während einer Anmeldung mit Microsoft oder Discord, höchstens 10 Minuten.
          </li>
          <li>
            <span className="mono">cc-theme</span> (lokaler Speicher): deine Wahl zwischen hell und dunkel, nur wenn du sie änderst.
          </li>
        </ul>
        <p>
          Alle drei sind für die von dir gewünschten Funktionen unbedingt erforderlich (§ 25 Abs. 2 Nr. 2 TDDDG). Deshalb
          fragen wir keine Einwilligung ab. Tracking-Cookies gibt es nicht.
        </p>

        <h2>Betriebsprotokolle</h2>
        <p>
          Fehler und sicherheitsrelevante Ereignisse, zum Beispiel ein abgelehnter Kisteninhalt, speichern wir mit
          Zuordnung zum Konto 90 Tage. Ebenso lange protokollieren wir, was du in Chest Catalog tust: Anmeldungen in Mod
          und Browser, registrierte, umbenannte oder entfernte Kisten, Änderungen am Inhalt (nur Version und Anzahl der
          Sorten, nicht der Inhalt selbst) und Teamaktionen. So können Admins Probleme nachvollziehen und Missbrauch
          erkennen. Aktionen von Admins, etwa das Sperren eines Kontos, protokollieren wir ein Jahr lang,
          damit sie nachvollziehbar bleiben (Art. 6 Abs. 1 lit. f DSGVO). Die Protokolle der Anwendung enthalten keine
          IP-Adressen und werden nach Größe automatisch überschrieben.
        </p>

        <h2>Empfänger</h2>
        <p>
          Der Server wird bei einem Hosting-Anbieter betrieben, der die Daten in unserem Auftrag verarbeitet
          (Art. 28 DSGVO). Darüber hinaus geben wir keine Daten weiter, außer an Mojang, Microsoft und Discord wie oben
          beschrieben.
        </p>

        <h2>Deine Rechte</h2>
        <p>
          Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung und Datenübertragbarkeit
          (Art. 15 bis 20 DSGVO) sowie das Recht, einer Verarbeitung auf Grundlage berechtigter Interessen zu widersprechen
          (Art. 21 DSGVO). Dein Konto mit allen Kisten und Geräten kannst du im Portal unter „Konto löschen“ selbst
          entfernen. Für alles andere genügt eine Nachricht an die Kontaktdaten im Impressum. Außerdem kannst du dich bei
          einer Datenschutz-Aufsichtsbehörde beschweren.
        </p>
        <p>
          Die Angaben brauchen wir, damit Chest Catalog funktioniert; ohne sie kannst du den Dienst nicht nutzen.
          Automatisierte Entscheidungen oder Profiling finden nicht statt.
        </p>
      </section>
    </PortalLayout>
  );
}
